import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsProgramBoardsRoute: InvariantJiraRoute = {
	name: 'plan-settings-program-boards',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards',
};
